import React, { useEffect, useRef, useState } from "react";

// Drop-in <img> replacement with a soft blur-up + fade-in on load.
// Keeps the same className as a normal <img> (e.g. "h-full w-full object-cover").
export default function BlurImage({ src, alt = "", className = "", eager = false, ...rest }) {
    const [loaded, setLoaded] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        setLoaded(false);
        if (ref.current && ref.current.complete && ref.current.naturalWidth > 0) {
            setLoaded(true);
        }
    }, [src]);

    return (
        <img
            ref={ref}
            src={src}
            alt={alt}
            loading={eager ? "eager" : "lazy"}
            decoding="async"
            onLoad={() => setLoaded(true)}
            style={{ backgroundColor: "#e8e1d4" }}
            className={`${className} transition duration-700 ease-out ${loaded ? "opacity-100 blur-0 scale-100" : "opacity-0 blur-md scale-[1.04]"}`}
            {...rest}
        />
    );
}
